import { createAuthClient } from '../../../../app/infrastructure/http/apiClient';
import {
  mapChatMessage,
  mapChatParticipant,
  mapChatRoom,
} from '../../application/mapChat';
import type {
  ChatMessage,
  ChatParticipant,
  ChatRoom,
  SendChatMessageInput,
} from '../../application/types';

/** Legacy dashboard chat endpoints — replace when backend /v1 chat exists. */
export async function fetchChatRooms(accessToken?: string): Promise<ChatRoom[]> {
  const response = await createAuthClient(accessToken).get('/dashboard/chat-room');
  const list = Array.isArray(response.data) ? response.data : [];
  return list.map(mapChatRoom);
}

export async function fetchChatParticipants(
  ids: string[],
  accessToken?: string,
): Promise<ChatParticipant[]> {
  if (ids.length === 0) {
    return [];
  }
  const client = createAuthClient(accessToken);
  const responses = await Promise.all(ids.map((id) => client.get(`/user/${id}`)));
  return responses.map((response) => mapChatParticipant(response.data));
}

export async function fetchChatMessages(
  chatRoomId: string,
  accessToken?: string,
): Promise<ChatMessage[]> {
  const response = await createAuthClient(accessToken).get(
    `/dashboard/messages/${chatRoomId}`,
  );
  const list = Array.isArray(response.data) ? response.data : [];
  return list.map(mapChatMessage);
}

export async function sendChatMessage(
  input: SendChatMessageInput,
  accessToken?: string,
): Promise<ChatMessage> {
  const response = await createAuthClient(accessToken).post('/dashboard/messages', {
    chatRoomID: Number(input.chatRoomId),
    message: input.body,
    status: 'new',
    toID: Number(input.toId),
    ownerID: Number(input.ownerId),
  });
  return mapChatMessage({
    ...response.data,
    chatRoomID: input.chatRoomId,
    message: input.body,
    status: 'new',
    ownerID: input.ownerId,
    toID: input.toId,
    createdAt: response.data?.createdAt ?? new Date().toISOString(),
    updatedAt: response.data?.updatedAt ?? new Date().toISOString(),
  });
}
